import { DateTime } from 'luxon';
import React from 'react';
import { useTranslation } from 'react-i18next';
export interface LastUpdateDataProps {
  // Define any props if needed
  date: Date;
}
export default function LastUpdateData({ date }: LastUpdateDataProps) {
  const { t, i18n } = useTranslation();
  return (
    <div className="last-update-data">
      {`${t('overview.meter.last.update')} ${DateTime.fromJSDate(date)
        .setLocale(i18n.language)
        .setZone('Europe/Brussels')
        .toFormat('EEEE dd/MM/yyyy')}`}
    </div>
  );
}
